import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';

export default function Comp() {
    const { useLang } = useGlobal();
    const { t } = useLang('delta_max_static');

    return (
        <div className={`${css.gsapdGroupD} gsapdGroupD3`}>
            <div className="a-msg-in">
                <div className="a-msg-box">
                    <div className="msg-line-a1">{t('ED')}</div>
                    <div className="msg-line-a2">{t('ED_desc')}</div>
                </div>
                <div className="a-img-box">
                    <div className="gsapdGroupe-canvas2" id="gsapdGroupe-canvas2"></div>
                </div>
            </div>
        </div>
    );
}
